<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;">
            <span class="text-muted fw-light">Payments /</span> Payments Link Information
        </h4>
        <mat-card>
            <mat-card-header class="mt-3 mb-4">
                <mat-icon class="nav-icon">payments</mat-icon>Payment Link Information
            </mat-card-header>

            <hr class="my-0 mt-3" />

            <mat-card-header class="mt-5 mb-5">
                <mat-icon class="nav-icon">payment</mat-icon>
                <div>Payment Link Id: {{this.custTrackingNo}}</div>
            </mat-card-header>

            <mat-card-content>
                <div class="d-flex align-items-start align-items-sm-center">
                    <div class="col-md-12 col-lg-12">
                        <div class="nav-align-top mb-4">
                            <ul class="nav nav-pills mb-3 nav-fill" role="tablist">

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button"
                                        (click)="scrollToSection('business')" class="nav-link active" role="tab"
                                        data-bs-toggle="tab" aria-selected="true">Business Information
                                    </button>
                                </mat-list>

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button"
                                        (click)="scrollToSection('service')" class="nav-link" role="tab"
                                        data-bs-toggle="tab" data-bs-target="#service" aria-selected="false">Service
                                        Information
                                    </button>
                                </mat-list>

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button" class="nav-link"
                                        (click)="scrollToSection('vendor')" role="tab" data-bs-toggle="tab"
                                        aria-selected="false">Vendor Information
                                    </button>
                                </mat-list>

                                <mat-list class="nav-item">
                                    <button mat-button color="primary" type="button" class="nav-link"
                                        (click)="scrollToSection('payee')" role="tab" data-bs-toggle="tab"
                                        aria-selected="false">Payee Information
                                    </button>
                                </mat-list>
                            </ul>
                        </div>
                    </div>
                </div>

                <form [formGroup]="businessTypeForm">
                    <div id="business"></div>
                    <mat-card class="mt-3 mb-3">
                        <mat-card-header>
                            Business Type
                        </mat-card-header>

                        <mat-card-content>
                            <mat-grid-list cols="4" rowHeight="200px">
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Date</mat-label>
                                            <input matInput formControlName="serviceDate" readonly>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Charge</mat-label>
                                            <input matInput formControlName="serviceCharges" readonly>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>

                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Type</mat-label>
                                            <mat-select formControlName="serviceType" name="serviceType"
                                                id="serviceType">
                                                <mat-option *ngFor="let serviceTypes of PaymentServiceTypes"
                                                    [value]="serviceTypes.paymentServiceTypeId">
                                                    {{ serviceTypes.serviceType }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="visibility: hidden;">
                                            <mat-label>Service Code</mat-label>
                                            <input matInput>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <!-- <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Type</mat-label>
                                            <mat-select formControlName="serviceType" readonly>
                                                <mat-option value="A">Service A</mat-option>
                                                <mat-option value="B">Appraisal Fee Service</mat-option>
                                                <mat-option value="C">Service B</mat-option>
                                            </mat-select>
                                            <mat-error>This feild is required</mat-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="visibility: hidden;">
                                            <mat-label>Service Code</mat-label>
                                            <input matInput>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile> -->
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Code</mat-label>
                                            <input matInput formControlName="serviceCode" readonly>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" style="visibility: hidden;">
                                            <mat-label>Service Code</mat-label>
                                            <input matInput>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Service Description</mat-label>
                                            <input matInput formControlName="serviceDesc" readonly>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline" style="visibility: hidden;">
                                            <mat-label>Service Code</mat-label>
                                            <input matInput>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </mat-card-content>
                    </mat-card>

                    <div id="service"></div>
                    <mat-card class="mb-3">
                        <mat-card-header>
                            <label *ngIf="containsAgent()">Service Information</label>
                            <label *ngIf="!containsAgent()">Property Information</label>
                            <!-- Property Information -->
                        </mat-card-header>
                        <mat-card-content>
                            <mat-grid-list cols="4" rowHeight="230px">
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Lender Name</mat-label>
                                            <input matInput formControlName="lenderName"    >
                                                
                                        </mat-form-field> -->

                                        <mat-form-field appearance="outline">
                                            <mat-label>Vendor</mat-label>
                                            <input matInput formControlName="vendorNameId" readonly>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Property Street</mat-label>
                                            <input matInput formControlName="propertyStreet" readonly>
                                        </mat-form-field>

                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Lender ID</mat-label>
                                            <input matInput formControlName="lenderId"    >
                                                
                                        </mat-form-field> -->
                                        <mat-form-field appearance="outline">
                                            <mat-label>Property State</mat-label>
                                            <input matInput formControlName="propertyState" readonly>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Property City</mat-label>
                                            <input matInput formControlName="propertyCity" readonly>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Vendor Name</mat-label>
                                            <input matInput formControlName="vendorNameId"    >
                                                
                                        </mat-form-field> -->
                                        <mat-form-field appearance="outline">
                                            <mat-label>Property Zipcode</mat-label>
                                            <input matInput formControlName="propertyZip" readonly>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Property Landmark</mat-label>
                                            <input matInput formControlName="propertyLandmark" readonly>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Loan ID</mat-label>
                                            <input matInput formControlName="loanId" readonly>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Reason</mat-label>
                                            <input matInput formControlName="reason" readonly>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </mat-card-content>
                    </mat-card>

                    <div id="vendor"></div>
                    <mat-card>
                        <mat-card-header>
                            Vendor Information
                        </mat-card-header>
                        <mat-card-content>
                            <mat-grid-list cols="4" rowHeight="130px">
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Vendor Name</mat-label>
                                            <input matInput formControlName="vendorName" readonly>

                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Vendor Id</mat-label>
                                            <input matInput formControlName="vendorId" readonly>

                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Vendor Address</mat-label>
                                            <input matInput formControlName="vendorAddress" readonly>

                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Vendor Email</mat-label>
                                            <input matInput formControlName="vendorEmail" readonly>

                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </mat-card-content>
                    </mat-card>

                    <div id="payee"></div>
                    <mat-card class="mt-3">
                        <mat-card-header>
                            Payee Information
                        </mat-card-header>
                        <mat-card-content>
                            <mat-grid-list cols="4" rowHeight="150px">
                                <mat-grid-tile>
                                    <div class="adminControls">

                                        <mat-form-field appearance="outline">
                                            <mat-label>First Name</mat-label>
                                            <input matInput formControlName="firstName" readonly>

                                        </mat-form-field>
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Payee Type</mat-label>
                                            <input matInput formControlName="payeeType"    >
                                                
                                        </mat-form-field> -->

                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Address</mat-label>
                                            <input matInput formControlName="address"    >
                                                
                                        </mat-form-field> -->

                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Zipcode</mat-label>
                                            <input matInput formControlName="zipCode"    >
                                                
                                        </mat-form-field> -->
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput formControlName="lastName" readonly>
                                        </mat-form-field>
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>First Name</mat-label>
                                            <input matInput formControlName="firstName"    >
                                                
                                        </mat-form-field> -->

                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>State</mat-label>
                                            <input matInput formControlName="state"    >
                                                
                                        </mat-form-field> -->

                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Country</mat-label>
                                            <input matInput formControlName="country"    >
                                                
                                        </mat-form-field> -->
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput formControlName="lastName"    >
                                                
                                        </mat-form-field> -->

                                        <!-- <mat-form-field appearance="outline">
                                            <mat-label>City</mat-label>
                                            <input matInput formControlName="city"    >
                                                
                                        </mat-form-field> -->

                                        <mat-form-field appearance="outline">
                                            <mat-label>Phone Number</mat-label>
                                            <input matInput formControlName="phoneNumber" placeholder="XXX-XXX-XXXX"
                                                readonly>
                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                                <mat-grid-tile>
                                    <div class="adminControls">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Email</mat-label>
                                            <input matInput formControlName="email" readonly>

                                        </mat-form-field>
                                    </div>
                                </mat-grid-tile>
                            </mat-grid-list>
                        </mat-card-content>
                    </mat-card>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>